export default __webpack_public_path__ + "static/media/user-role-assigned.5cf598a3.svg";